import { Component } from '@angular/core';
import { CredentialType } from 'enums/CredentialType';
import { TaskAreaModel } from 'models/generated/Entities.GormCrm.TaskArea';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CredentialRequired } from 'services/credential.service';
import { ComponentUrl } from 'services/navigation.service';
import { NotificationService } from 'services/notification.service';
import { TaskService } from 'services/task.service';
import { EditTaskAreaComponent } from './edit-task-area.component';

@Component({
	templateUrl: './list-task-areas.component.html',
	imports: [Layout, ListView, EditTaskAreaComponent, TranslatePipe]
})
@ComponentUrl('list-task-areas')
@CredentialRequired(CredentialType.UsersAccessFull)
export class ListTaskAreasComponent {

	taskAreas: TaskAreaModel[] = [];
	activeTaskArea?: TaskAreaModel;

	constructor(private readonly taskService: TaskService,
		private readonly notificationService: NotificationService) {
		this.updateList();
	}

	updateList() {
		this.taskService.getAllTaskAreas().then(taskAreas => {
			this.taskAreas = taskAreas;
		});
	}
	updateTaskArea(activeTaskArea: TaskAreaModel) {
		this.activeTaskArea = activeTaskArea;
		this.updateList();
	}

	deleteTaskArea(taskArea: TaskAreaModel) {
		this.notificationService.confirm('task-area.prompt-for-delete', { 'taskArea': taskArea.name }).subscribe(result => {
			if (result) {
				this.taskService.deleteTaskArea(taskArea).then(() => {
					if (this.activeTaskArea && taskArea.id === this.activeTaskArea.id) this.activeTaskArea = undefined;
					this.updateList();
				});
			}
		});
	}

	createTaskArea() {
		this.activeTaskArea = new TaskAreaModel();
	}

}
